module.exports = __webpack_public_path__ + "images/fold_icon.b426801fb5cf28a484aa4d6e733aa4fe.png";